import { Box } from '@mui/material'
import { SummaryCard as StyledSummaryCard, StatValue, StatLabel } from './styledComponents'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import TrendingDownIcon from '@mui/icons-material/TrendingDown'

export default function SummaryCard({ title, value, subtitle, trend, icon: Icon, color = 'primary' }) {
  return (
    <StyledSummaryCard>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
        {Icon && (
          <Box
            sx={{
              backgroundColor: `${color}.light`,
              color: `${color}.main`,
              borderRadius: 2,
              p: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon />
          </Box>
        )}
        {trend !== undefined && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {trend > 0 ? (
              <TrendingUpIcon sx={{ color: 'success.main', fontSize: '1rem' }} />
            ) : (
              <TrendingDownIcon sx={{ color: 'error.main', fontSize: '1rem' }} />
            )}
          </Box>
        )}
      </Box>
      <StatValue>{value}</StatValue>
      <StatLabel>{title}</StatLabel>
      {subtitle && (
        <Box sx={{ mt: 1, fontSize: '0.75rem', color: 'text.secondary' }}>{subtitle}</Box>
      )}
    </StyledSummaryCard>
  )
}
